import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import AdminSubHeader from "../../../layouts/partials/AdminSubheader";
import { ZONES_ACTIONS } from "../../../../redux/zones/actions";
import ZonesForm from "../../../forms/ZonesForm";
import { selectVenues } from "../../../../redux/venues/selectors";
import { VENUES_ACTIONS } from "../../../../redux/venues/actions";
import { selectZones } from "../../../../redux/zones/selectors";

class ZonesEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      zones: []
    };

    this._handleSubmit = this._handleSubmit.bind(this);
  }

  static propTypes = {
    loadVenues: PropTypes.func,
    loadZones: PropTypes.func,
    zones: PropTypes.array,
    updateRequest: PropTypes.func,
    match: PropTypes.object,
    "match.params": PropTypes.object,
    "match.params.id": PropTypes.string,
    venues: PropTypes.array
  };

  UNSAFE_componentWillMount() {
    this.props.loadVenues();
    this.props.loadZones();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      zones: nextProps.zones
    });
  }

  _handleSubmit(values) {
    const data = {
      name: values.name,
      code: values.code,
      catering: values.catering ? 1 : 0,
      venueId: parseInt(values.venue, 10),
      dailyLimitPerCompanyUser:
        values.dailyLimitPerCompanyUser === ""
          ? null
          : values.dailyLimitPerCompanyUser,
      inForOut: values.inForOut
    };

    this.props.updateRequest(values.id, data);
  }

  render() {
    const breadcrumbs = [
      {
        title: "Zones",
        to: "/admin/zones"
      }
    ];

    const { match, venues } = this.props;
    const { zones, isCreating } = this.state;

    const zone = zones.filter(
      zone => zone.id === parseInt(match.params.id, 10)
    )[0];

    return [
      <AdminSubHeader
        title="Edit Zone"
        key="subheader"
        breadcrumbs={breadcrumbs}
      />,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-xl-12">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-information" />
                    </span>
                    <h3 className="m-portlet__head-text">Zone Info</h3>
                  </div>
                </div>
              </div>
              <ZonesForm
                onSubmit={this._handleSubmit}
                venues={venues}
                isCreating={isCreating}
                zone={zone}
              />
            </div>
          </div>
        </div>
      </div>
    ];
  }
}

const mapStateToProps = function(state, props) {
  return {
    venues: selectVenues(state),
    zones: selectZones(state)
  };
};

const mapDispatchToProps = dispatch => ({
  updateRequest: (id, values) =>
    dispatch(ZONES_ACTIONS.updateRequest(id, values)),
  loadVenues: () => dispatch(VENUES_ACTIONS.loadAllRequest()),
  loadZones: () => dispatch(ZONES_ACTIONS.loadAllRequest())
});

export default connect(mapStateToProps, mapDispatchToProps)(ZonesEdit);
